export const SIGN_UP_FREE_TIER_IMG = 'https://lp.singular.net/free-tier-sign-up-page/';
export const SIGN_UP_UNIFIED_TIER_IMG = 'https://lp.singular.net/sign-up-form-logos/';
export const SIGN_UP_MIXPANEL_PREFIX = 'signup';
export const RECAPTCHA_SIGNUP_SITE_KEY = '6LckSVkqAAAAAOkR65IdXoYCmjVGZB9PlMUAoi_-';
